<template>
  <page-wrapper :title="title" ref="pageEl">
    <div class="filter">
      <div class="row">
        <div class="col-4 mb-3">
          <div class="label mb-1">Booking number</div>
          <el-input v-model="query.bookingNo" />
        </div>
        <div class="col-4 mb-3">
          <div class="label mb-1">ห้องประชุม</div>
          <el-select v-model="query.room" clearable style="width: 100%">
            <el-option
              v-for="room in roomConferenceTitleDropdown"
              :key="room.id"
              :value="room.id"
              :label="room.title"
            ></el-option>
          </el-select>
        </div>
        <div class="col-4 mb-3">
          <div class="label mb-1">สถานะ</div>
          <el-select v-model="query.status" clearable style="width: 100%">
            <el-option
              v-for="room in conferenceBookingStatusDropdown"
              :key="room.value"
              :value="room.value"
              :label="room.label"
            ></el-option>
          </el-select>
        </div>
        <div class="col-4 mb-3">
          <div class="label mb-1">ชื่อผู้จอง</div>
          <el-input v-model="query.firstName" />
        </div>
        <div class="col-4 mb-3">
          <div class="label mb-1">นามสกุลผู้จอง</div>
          <el-input v-model="query.lastName" />
        </div>
        <div class="col-4 mb-3 search">
          <sc-button
            class="search-button"
            variant="primary"
            @click="handleSearch"
            >ค้นหา</sc-button
          >
        </div>
      </div>
    </div>
    <div class="list">
      <div class="p-4 text-center" v-if="noResult">ไม่มีข้อมูล</div>
      <template v-else>
        <p class="ml-4 mb-3">{{ totalCount }}</p>
        <div class="row-header">
          <div class="cell center">Booking No.</div>
          <div class="cell">ข้อมูลผู้จอง</div>
          <div class="cell">ห้องที่จอง</div>
          <div class="cell">วันที่จอง</div>
          <div class="cell">ประเภทการจอง</div>
          <div class="cell center">จำนวนผู้เข้าร่วม</div>
          <div class="cell center">สถานะการจอง</div>
        </div>
        <conference-list-row
          v-for="item in bookList"
          :key="item.bookNumber"
          v-bind="item"
        ></conference-list-row>
      </template>
    </div>
    <div class="wrapper text-right padding-adjust">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="query.take"
        :current-page="query.page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import { Input, Pagination, Select, Option, Checkbox } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import { timeDurationDropdown } from "../../../components/other-web/Conference/VariableStatic";
import { conferenceBookingStatus } from "@/lib/mapper";
import { convertDateTimeToTimeText } from "@/lib/dateTime";
import ConferenceListRow from "../component/ConferenceListRow";
import { convertCamelToSnake } from '../../../lib/util';

export default {
  components: {
    "page-wrapper": PageWrapper,
    "el-input": Input,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    "sc-button": ScButton,
    "conference-list-row": ConferenceListRow,
    "el-pagination": Pagination,
  },
  data() {
    const title = "รายการจอง";

    const query = {
      bookingNo: null,
      room: null,
      status: null,
      page: 1,
      take: 20,
      firstName: null,
      lastName: null,
    };

    return {
      title,
      query,
      roomConferenceTitleDropdown: [],
      bookList: [],
      total: 0,
    };
  },
  created() {
    this.setupRoomConferenceTitleDropdown();
    this.setFormBookList();
  },
  computed: {
    noResult() {
      return this.bookList.length === 0;
    },
    conferenceBookingStatusDropdown() {
      return conferenceBookingStatus;
    },
    totalCount() {
      const limit = this.query.take;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.bookList.length;


      const isLastPage = limit > currentTotalItem;
      const currentPage = +this.query.page || 1;
      const end = isLastPage ? total : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
  },
  watch: {
    "$route.query"() {
      this.setFormBookList();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    },
  },
  methods: {
    setFormBookList() {
      this.setupForm();
      this.setupBookList();
    },
    setupForm() {
      this.query = {
        bookingNo: this.$route.query.bookingNo || null,
        room: this.$route.query.room || null,
        status: this.$route.query.status || null,
        page: this.$route.query.page && this.$route.query.page !== ""
          ? +this.$route.query.page || 1
          : 1,
        firstName: this.$route.query.firstName || null,
        lastName: this.$route.query.lastName || null,
        take: this.query.take
      };
    },
    async setupRoomConferenceTitleDropdown() {
      this.roomConferenceTitleDropdown =
        await this.fetchConferenceProjectList();
    },
    async fetchConferenceProjectList() {
      const query = {
        titleonly: true,
      };

      try {
        return await baanRueJaiClient.others.conference.getConferenceProjectList(
          undefined,
          query
        );
      } catch (err) {
        console.error(err);
        return [];
      }
    },
    async setupBookList() {
      const { data, total } = await this.fetchBookList();

      this.total = total;
      if (data.length === 0) this.bookList = null;

      this.bookList = data.map((bookDetail) => {
        const name =
          (bookDetail.first_name || "-") + " " + (bookDetail.last_name || "-");
        const mobile = bookDetail.mobile || "-";
        const email = bookDetail.email || "-";
        const roomType = bookDetail.room_type;
        const bookingStatus = conferenceBookingStatus.find(
          (stat) => stat.value === bookDetail.status
        );

        const roomDates =
          bookDetail.booking_date && bookDetail.booking_date.length > 0
            ? bookDetail.booking_date.map((bookDate) => {
                const timeDuration = timeDurationDropdown.find(
                  (time) => time.value === bookDate.time_duration
                );

                return {
                  date: convertDateTimeToTimeText(bookDate.date, "dd MMM yyyy"),
                  timeDuration: timeDuration ? timeDuration.label : "-",
                  numberOfPeople: bookDate.number_of_people,
                };
              })
            : undefined;

        const bookingDate = roomDates
          ? roomDates
              .map((date, dateIndex) => `${dateIndex + 1}. ${date.date}`)
              .join("\n")
          : undefined;

        const bookingTimeDuration = roomDates
          ? roomDates.map((date) => date.timeDuration).join("\n")
          : undefined;

        const numberOfPeople = roomDates
          ? roomDates.map((date) => date.numberOfPeople).join("\n")
          : undefined;

        const route = { name: "ConferenceBookingDetailStaff", params: { id: bookDetail.id } };

        return {
          bookNumber: bookDetail.id,
          customerDetail: name + "\n" + mobile + "\n" + email,
          roomTitle: (roomType && roomType.title) || "",
          bookingDate,
          bookingTimeDuration,
          numberOfPeople,
          status: bookingStatus
            ? bookingStatus
            : { label: "unknown", value: "UNKNOWN" },
          route
        };
      });
    },
    async fetchBookList() {
      try {
        const query = convertCamelToSnake(this.query)

        return await baanRueJaiClient.others.conference.getBooks(query);
      } catch (err) {
        console.error(err);
        return [];
      }
    },
    handleSearch() {
      if (
        !this.$route.query
        || (+this.query.page === +this.$route.query.page)
      ) {
        this.query.page = 1;
      }

      this.$router.push({ query: this.query });
    },
    handleCurrentChange(page) {
      const query = { ...this.$route.query, page };

      this.$router.push({ query });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.filter {
  padding: 20px;
}

.search-button {
  float: right;
  margin-top: 10px;
}

.row-header {
  display: grid;
  grid-template-columns: 150px 180px 150px 140px 270px 120px 1fr;

  grid-gap: 10px;

  border-bottom: $border;

  font-weight: bold;

  > .center {
    text-align: center;
  }
}

.header {
  padding: 30px;
  border-bottom: $border;
}
</style>



// WEBPACK FOOTER //
// src/features/conferences/pages/ConferenceList.vue